import { Subcategories } from 'modules/automations/components/AddAutomationBlockModal/actions'

import SubcategoryField from 'modules/automations/components/AddAutomationBlockModal/List/Items/SubcategoryField'
import type { ConditionsGroup } from 'modules/automations/components/AddAutomationBlockModal/List/Items/types'

export interface Props {
  items: ConditionsGroup[] | JSX.Element[]
  extensionFeatureHasConditions: boolean
}

export function Conditions({ items, extensionFeatureHasConditions }: Props) {
  const getConditions = () => {
    if (extensionFeatureHasConditions) {
      const conditionsGroups = items as ConditionsGroup[]

      return conditionsGroups.map((item: ConditionsGroup, index: number) => {
        return (
          <SubcategoryField
            key={index}
            label={item.label}
            extensionFeatureHasConditions={extensionFeatureHasConditions}
          >
            {item.conditions}
          </SubcategoryField>
        )
      })
    }

    return Object.keys(Subcategories).map((key) => {
      const catItems = (items as JSX.Element[]).filter(
        (item: JSX.Element) => item.props.action.subcategory === key
      )

      if (catItems.length === 0) return

      return (
        <SubcategoryField
          key={key}
          label={key}
          extensionFeatureHasConditions={extensionFeatureHasConditions}
        >
          {catItems}
        </SubcategoryField>
      )
    })
  }

  return <>{getConditions()}</>
}
